/**
 * Veluna Cart Drawer v3.1 - AG1 Enhancements
 * - Free shipping progress bar ($50 threshold)
 * - Staggered item entry animation
 * - Image fallback for null images
 * - Uses item.key for reliable cart operations
 */

(function() {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 5000; // $50.00 in cents
  var cartDrawer = null;
  var cartDrawerBackdrop = null;

  function initCartDrawer() {
    cartDrawer = document.querySelector('[data-cart-drawer], [data-veluna-cart-drawer], .veluna-cart-drawer');
    if (!cartDrawer) {
      setTimeout(initCartDrawer, 100);
      return;
    }

    cartDrawerBackdrop = cartDrawer.querySelector('.veluna-cart-drawer__backdrop, [data-veluna-cart-overlay]');

    // Use event delegation so re-rendering the drawer header/backdrop doesn't break closing.
    // Capture-phase so we can reliably close even if inner handlers stop propagation.
    if (!document.__velunaCartDrawerDelegatedClose) {
      document.__velunaCartDrawerDelegatedClose = true;
      document.addEventListener('click', function(e) {
        try {
          var t = e.target;
          if (!t || !t.closest) return;
          var closeTarget = t.closest('.veluna-cart-drawer__close');
          var backdropTarget = t.closest('.veluna-cart-drawer__backdrop, [data-veluna-cart-overlay]');
          if (closeTarget || backdropTarget) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            closeCartDrawer();
            // Hard-close second pass to beat any race that re-adds open styles/classes.
            setTimeout(closeCartDrawer, 40);
          }
        } catch (err) {}
      }, true);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('veluna-cart-drawer--open')) {
        closeCartDrawer();
      }
    });

    attachCartIconHandlers();
    loadCartContents();
    console.log('[Cart] v3.1 initialized');
  }

  function attachCartIconHandlers() {
    var selectors = [
      '[data-cart-drawer-open]',
      '.veluna-header__cart',
      'a[href*="/cart"]'
    ];
    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(btn) {
        var newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
        newBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          openCartDrawer();
        });
      });
    });
  }

  function openCartDrawer() {
    // Clear suppression flag — user explicitly wants drawer open
    window.__velunaDrawerClosedAt = 0;
    if (!cartDrawer) {
      cartDrawer = document.querySelector('[data-cart-drawer], [data-veluna-cart-drawer], .veluna-cart-drawer');
      if (!cartDrawer) {
        console.error('[Cart] openCartDrawer: drawer element not found');
        return;
      }
      cartDrawerBackdrop = cartDrawer.querySelector('.veluna-cart-drawer__backdrop, [data-veluna-cart-overlay]');
    }
    var panel = cartDrawer.querySelector('.veluna-cart-drawer__panel');

    // Step 1: Clear ALL stale inline styles from previous close operations
    cartDrawer.style.cssText = '';
    if (panel) panel.style.cssText = '';
    if (cartDrawerBackdrop) cartDrawerBackdrop.style.cssText = '';

    // Step 2: Toggle CSS classes (drives the Arrae premium CSS)
    cartDrawer.classList.remove('veluna-cart-drawer--closed');
    cartDrawer.classList.add('veluna-cart-drawer--open');
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');

    // Step 3: Nuclear inline style fallback — guarantees visibility regardless of CSS cascade
    // These use !important to override any conflicting external/base rules.
    cartDrawer.style.setProperty('display', 'block', 'important');
    cartDrawer.style.setProperty('position', 'fixed', 'important');
    cartDrawer.style.setProperty('top', '0', 'important');
    cartDrawer.style.setProperty('right', '0', 'important');
    cartDrawer.style.setProperty('left', 'auto', 'important');
    cartDrawer.style.setProperty('bottom', '0', 'important');
    cartDrawer.style.setProperty('visibility', 'visible', 'important');
    cartDrawer.style.setProperty('opacity', '1', 'important');
    cartDrawer.style.setProperty('pointer-events', 'auto', 'important');
    cartDrawer.style.setProperty('z-index', '999999', 'important');
    if (panel) {
      panel.style.setProperty('display', 'flex', 'important');
      panel.style.setProperty('position', 'fixed', 'important');
      panel.style.setProperty('top', '0', 'important');
      panel.style.setProperty('bottom', '0', 'important');
      panel.style.setProperty('transform', 'translateX(0)', 'important');
      panel.style.setProperty('visibility', 'visible', 'important');
      panel.style.setProperty('right', '0', 'important');
      panel.style.setProperty('pointer-events', 'auto', 'important');
      panel.style.setProperty('z-index', '999999', 'important');
    }
    if (cartDrawerBackdrop) {
      cartDrawerBackdrop.style.setProperty('display', 'block', 'important');
      cartDrawerBackdrop.style.setProperty('opacity', '1', 'important');
      cartDrawerBackdrop.style.setProperty('pointer-events', 'auto', 'important');
    }

    // Step 4: Lock body scroll
    document.body.style.overflow = 'hidden';
    document.body.classList.add('cart-drawer-open');

    // Step 5: Ensure arrae-drawer class is on <html> (CSS activation)
    document.documentElement.classList.add('veluna-ux--arrae-drawer');

    loadCartContents();
    console.log('[Cart] drawer opened (v3.2 nuclear)');
  }

  function closeCartDrawer() {
    // Re-query element references every close (DOM can be re-rendered)
    var drawerEl = cartDrawer || document.querySelector('[data-cart-drawer], [data-veluna-cart-drawer], .veluna-cart-drawer');
    if (!drawerEl) return;
    cartDrawer = drawerEl;

    // Suppression flag used by any fetch interceptor to avoid immediate re-open races
    window.__velunaDrawerClosedAt = Date.now();

    var panel = drawerEl.querySelector('.veluna-cart-drawer__panel');
    var backdrop = drawerEl.querySelector('.veluna-cart-drawer__backdrop, [data-veluna-cart-overlay]');

    drawerEl.classList.remove('veluna-cart-drawer--open');
    drawerEl.classList.remove('is-open');
    drawerEl.classList.add('veluna-cart-drawer--closed');
    drawerEl.setAttribute('aria-hidden', 'true');

    // Clear inline styles first
    drawerEl.style.cssText = '';
    if (panel) panel.style.cssText = '';
    if (backdrop) backdrop.style.cssText = '';
    if (cartDrawerBackdrop && cartDrawerBackdrop !== backdrop) {
      try { cartDrawerBackdrop.style.cssText = ''; } catch (e) {}
    }

    // Hard hide safeguards in case another script leaves !important open styles
    try {
      drawerEl.style.setProperty('display', 'none', 'important');
      drawerEl.style.setProperty('opacity', '0', 'important');
      drawerEl.style.setProperty('visibility', 'hidden', 'important');
      drawerEl.style.setProperty('pointer-events', 'none', 'important');
    } catch (e) {}
    if (panel) {
      try {
        panel.style.setProperty('transform', 'translateX(100%)', 'important');
        panel.style.setProperty('pointer-events', 'none', 'important');
      } catch (e) {}
    }
    if (backdrop) {
      try {
        backdrop.style.setProperty('display', 'none', 'important');
        backdrop.style.setProperty('opacity', '0', 'important');
        backdrop.style.setProperty('pointer-events', 'none', 'important');
      } catch (e) {}
    }

    try { document.body.style.overflow = ''; } catch (e) {}
    try { document.body.style.position = ''; } catch (e) {}
    try { document.body.style.top = ''; } catch (e) {}
    try { document.body.style.width = ''; } catch (e) {}
    try { document.body.style.height = ''; } catch (e) {}
    try { document.body.style.overscrollBehavior = ''; } catch (e) {}
    try { document.documentElement.style.overflow = ''; } catch (e) {}
    try { document.body.classList.remove('cart-drawer-open', 'drawer-open'); } catch (e) {}

    // Keep CSS scope class on html; removing it can break next open path
    console.log('[Cart] drawer closed (v3.5 hardened)');
  }

  function loadCartContents() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderCartContents(cart);
        updateCartCount(cart.item_count);
        updateShippingBar(cart.total_price);
        if (window.VelunaCrossSell && typeof window.VelunaCrossSell.render === 'function') {
          window.VelunaCrossSell.render();
        }
      })
      .catch(function(e) { console.error('[Cart] Load error:', e); });
  }

  /* ---- Shipping Progress Bar ---- */
  function updateShippingBar(totalCents) {
    var textEl = document.querySelector('[data-shipping-text]');
    var fillEl = document.querySelector('[data-shipping-fill]');
    if (!textEl || !fillEl) return;

    var remaining = FREE_SHIPPING_THRESHOLD - totalCents;
    var pct = Math.min(100, Math.round((totalCents / FREE_SHIPPING_THRESHOLD) * 100));

    if (totalCents === 0) {
      textEl.innerHTML = 'Free shipping on orders $50+';
      fillEl.style.width = '0%';
      fillEl.style.background = '#e0e0e0';
    } else if (remaining > 0) {
      textEl.innerHTML = 'You\'re <strong>$' + (remaining / 100).toFixed(2) + '</strong> away from free shipping!';
      fillEl.style.width = pct + '%';
      fillEl.style.background = 'linear-gradient(90deg, #c97d60, #d4956f)';
    } else {
      textEl.innerHTML = '🎉 You\'ve unlocked <strong>free shipping!</strong>';
      fillEl.style.width = '100%';
      fillEl.style.background = 'linear-gradient(90deg, #10b981, #34d399)';
    }
  }

  /* ---- Render Cart Items with Stagger ---- */
  function renderCartContents(cart) {
    var itemsContainer = cartDrawer ? cartDrawer.querySelector('[data-cart-items]') : null;
    var emptyContainer = cartDrawer ? cartDrawer.querySelector('[data-cart-empty]') : null;
    var footer = cartDrawer ? cartDrawer.querySelector('[data-cart-footer]') : null;
    var subtotal = cartDrawer ? cartDrawer.querySelector('[data-cart-subtotal]') : null;

    if (!itemsContainer || !emptyContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.style.display = 'none';
      emptyContainer.style.display = 'block';
      if (footer) footer.style.display = 'none';
      return;
    }

    itemsContainer.style.display = 'block';
    emptyContainer.style.display = 'none';
    if (footer) footer.style.display = 'block';

    function getProp(item, key) {
      try {
        return item && item.properties && item.properties[key] != null ? String(item.properties[key]) : '';
      } catch (e) {
        return '';
      }
    }

    function isBundleSubscriptionComponent(item) {
      if (!item || !item.properties) return false;
      var parentHandle = getProp(item, '_bundle_parent_handle');
      if (!parentHandle) return false;
      var purchaseType = getProp(item, '_purchase_type');
      return purchaseType === 'subscribe';
    }

    function buildScheduleLabel(monthsRaw) {
      var n = parseInt(String(monthsRaw || ''), 10);
      if (!n || isNaN(n) || n <= 0) return '';
      return n === 1 ? '1 Month Delivery' : (n + ' Month Delivery');
    }

    // First pass: collapse subscription bundle component items into groups.
    var entries = [];
    var bundleByKey = new Map();

    cart.items.forEach(function(item, index) {
      if (!isBundleSubscriptionComponent(item)) {
        entries.push({ kind: 'item', index: index, item: item });
        return;
      }

      var groupKey = getProp(item, '_bundle_group_key') || (getProp(item, '_bundle_parent_handle') + '::' + getProp(item, '_subscription_schedule'));
      if (!groupKey) {
        entries.push({ kind: 'item', index: index, item: item });
        return;
      }

      var group = bundleByKey.get(groupKey);
      if (!group) {
        group = {
          groupKey: groupKey,
          index: index,
          parentHandle: getProp(item, '_bundle_parent_handle'),
          title: getProp(item, '_bundle_parent_title') || 'Bundle',
          schedule: getProp(item, '_subscription_schedule'),
          keys: [],
          totalPrice: 0,
          totalCompare: 0,
          discount: 0,
          image: getProp(item, '_bundle_parent_image') || item.image || (item.featured_image ? item.featured_image.url : '') || ''
        };
        bundleByKey.set(groupKey, group);
        entries.push({ kind: 'bundle', index: index, group: group });
      }

      group.keys.push(item.key || String(item.id));
      group.totalPrice += (typeof item.final_line_price === 'number' ? item.final_line_price : 0);
      if (item.selling_plan_allocation) {
        group.totalCompare += (item.selling_plan_allocation.compare_at_price || 0);
        if (!group.discount && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.price_adjustments && item.selling_plan_allocation.selling_plan.price_adjustments[0]) {
          group.discount = item.selling_plan_allocation.selling_plan.price_adjustments[0].value || 0;
        }
      }
    });

    // Preserve original order by first occurrence.
    entries.sort(function(a, b) { return a.index - b.index; });

    var itemsHTML = entries.map(function(entry, renderIndex) {
      // Stagger animation delay: 60ms per rendered row
      var delay = renderIndex * 60;

      if (entry.kind === 'bundle') {
        var group = entry.group;
        var title = group.title || 'Bundle';
        var safeTitle = title.replace(/"/g, '&quot;');
        var keysValue = group.keys.join('|');

        var imgURL = group.image || '';
        var imgHTML;
        if (imgURL) {
          var sizedImg = imgURL + (imgURL.indexOf('?') > -1 ? '&' : '?') + 'width=200';
          imgHTML = '<img src="' + sizedImg + '" alt="' + safeTitle + '" loading="lazy">';
        } else {
          imgHTML = '<div style="width:100%;height:100%;background:#f5f5f5;border-radius:6px;display:flex;align-items:center;justify-content:center;">'
            + '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5">'
            + '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>'
            + '</svg></div>';
        }

        var scheduleLabel = buildScheduleLabel(group.schedule);
        var schedNum = parseInt(String(group.schedule || ''), 10) || 0;
        var subscriptionDesc = '';
        if (group.discount > 0) {
          subscriptionDesc = '<div style="display:flex;align-items:center;gap:4px;margin-top:2px;"><span style="font-size:0.7rem;font-weight:600;color:#7FB069;background:rgba(127,176,105,0.1);padding:1px 6px;border-radius:3px;white-space:nowrap;">Save ' + group.discount + '%</span></div>';
        }
        var priceHTML;
        if (group.totalCompare > 0 && group.totalCompare > group.totalPrice) {
          priceHTML = '<span style="color: var(--color-success, #7FB069); font-weight: 600;">' + formatMoney(group.totalPrice) + '</span> <span style="text-decoration: line-through; color: #999; font-size: 0.8125rem;">' + formatMoney(group.totalCompare) + '</span>';
        } else {
          priceHTML = formatMoney(group.totalPrice);
        }

        return '<div class="veluna-cart-drawer__item veluna-stagger" data-cart-bundle-key="' + group.groupKey + '" style="animation-delay: ' + delay + 'ms">'
          + '<div class="veluna-cart-drawer__item-image">' + imgHTML + '</div>'
          + '<div class="veluna-cart-drawer__item-details">'
          + '<h3 class="veluna-heading-sm">' + title + '</h3>'
          + (scheduleLabel ? '<p class="veluna-body-muted">' + scheduleLabel + '</p>' : '')
          + subscriptionDesc
          + '<div class="veluna-cart-drawer__item-price">' + priceHTML + '</div>'
          + '<div class="veluna-cart-drawer__item-quantity">'
          + '<button type="button" class="veluna-cart-drawer__quantity-btn" data-cart-remove-bundle="' + keysValue + '" aria-label="Remove bundle">&#8722;</button>'
          + '<span class="veluna-cart-drawer__quantity-value">1</span>'
          + '<span style="width:28px;"></span>'
          + '</div>'
          + '</div>'
          + '<button type="button" class="veluna-cart-drawer__item-remove" data-cart-remove-bundle="' + keysValue + '" aria-label="Remove">&times;</button>'
          + '</div>';
      }

      var item = entry.item;
      var title = item.product_title || item.title || 'Product';
      var safeTitle = title.replace(/"/g, '&quot;');
      var itemKey = item.key || String(item.id);

      // Image with fallback
      var imgURL = item.image || (item.featured_image ? item.featured_image.url : '') || '';
      var imgHTML;
      if (imgURL) {
        var sizedImg = imgURL + (imgURL.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        imgHTML = '<img src="' + sizedImg + '" alt="' + safeTitle + '" loading="lazy">';
      } else {
        imgHTML = '<div style="width:100%;height:100%;background:#f5f5f5;border-radius:6px;display:flex;align-items:center;justify-content:center;">'
          + '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5">'
          + '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>'
          + '</svg></div>';
      }

      // Build subscription description + savings price for individual items
      var itemSubscriptionHTML = '';
      var itemPriceHTML = formatMoney(item.final_line_price);
      if (item.selling_plan_allocation) {
        var spa = item.selling_plan_allocation;
        var planName = (spa.selling_plan && spa.selling_plan.name) || '';
        var itemDiscount = (spa.selling_plan && spa.selling_plan.price_adjustments && spa.selling_plan.price_adjustments[0]) ? spa.selling_plan.price_adjustments[0].value : 0;
        var nameLower = planName.toLowerCase();
        var itemMonths = nameLower.indexOf('6 month') !== -1 ? '6' : (nameLower.indexOf('3 month') !== -1 ? '3' : '1');
        if (itemDiscount > 0) {
          itemSubscriptionHTML = '<div style="display:flex;align-items:center;gap:4px;margin-top:2px;"><span style="font-size:0.7rem;font-weight:600;color:#7FB069;background:rgba(127,176,105,0.1);padding:1px 6px;border-radius:3px;white-space:nowrap;">Save ' + itemDiscount + '%</span></div>';
        }
        var itemCompare = spa.compare_at_price;
        var itemSalePrice = spa.price;
        if (itemCompare && itemCompare > itemSalePrice) {
          itemPriceHTML = '<span style="color: var(--color-success, #7FB069); font-weight: 600;">' + formatMoney(itemSalePrice) + '</span> <span style="text-decoration: line-through; color: #999; font-size: 0.8125rem;">' + formatMoney(itemCompare) + '</span>';
        }
      } else {
        // Volume discount support for one-time purchases (Shopify automatic discounts)
        var volDiscount = item.total_discount || 0;
        if (!volDiscount && item.discounts && item.discounts.length > 0) {
          item.discounts.forEach(function(d) { volDiscount += (d.amount || 0); });
        }
        if (volDiscount > 0 && item.original_line_price > 0) {
          var volPct = Math.round(volDiscount * 100 / item.original_line_price);
          if (volPct > 0) {
            itemSubscriptionHTML = '<div style="display:flex;align-items:center;gap:4px;margin-top:2px;"><span style="font-size:0.7rem;font-weight:600;color:#7FB069;background:rgba(127,176,105,0.1);padding:1px 6px;border-radius:3px;white-space:nowrap;">Save ' + volPct + '%</span></div>';
          }
          var discountedTotal = item.original_line_price - volDiscount;
          itemPriceHTML = '<span style="color: var(--color-success, #7FB069); font-weight: 600;">' + formatMoney(discountedTotal) + '</span> <span style="text-decoration: line-through; color: #999; font-size: 0.8125rem;">' + formatMoney(item.original_line_price) + '</span>';
        }
      }

      return '<div class="veluna-cart-drawer__item veluna-stagger" data-cart-item-key="' + itemKey + '" style="animation-delay: ' + delay + 'ms">'
        + '<div class="veluna-cart-drawer__item-image">' + imgHTML + '</div>'
        + '<div class="veluna-cart-drawer__item-details">'
        + '<h3 class="veluna-heading-sm">' + title + '</h3>'
        + (function() {
          var packProp = getProp(item, 'Pack');
          var typeProp = getProp(item, 'Type');
          var planProp = getProp(item, 'Plan');
          if (packProp) {
            return '<p class="veluna-body-muted" style="color:#7FB069;font-weight:500;">' + packProp + (typeProp ? ' &mdash; ' + typeProp : '') + '</p>';
          } else if (!item.selling_plan_allocation && item.variant_title && item.variant_title.indexOf('Month Delivery') !== -1) {
            return '<p class="veluna-body-muted" style="color:#7FB069;font-weight:500;">' + item.quantity + (item.quantity === 1 ? ' Set' : ' Sets') + ' &mdash; ' + item.variant_title + '</p>';
          } else if (planProp) {
            return '<p class="veluna-body-muted" style="color:#7FB069;font-weight:500;">' + planProp + '</p>';
          } else if (item.variant_title && item.variant_title !== 'Default Title') {
            return '<p class="veluna-body-muted">' + item.variant_title + '</p>';
          }
          return '';
        })()
        + itemSubscriptionHTML
        + '<div class="veluna-cart-drawer__item-price">' + itemPriceHTML + '</div>'
        + '<div class="veluna-cart-drawer__item-quantity">'
        + '<button type="button" class="veluna-cart-drawer__quantity-btn" data-cart-change="' + itemKey + '" data-delta="-1">&#8722;</button>'
        + '<span class="veluna-cart-drawer__quantity-value">' + item.quantity + '</span>'
        + '<button type="button" class="veluna-cart-drawer__quantity-btn" data-cart-change="' + itemKey + '" data-delta="1">+</button>'
        + '</div>'
        + '</div>'
        + '<button type="button" class="veluna-cart-drawer__item-remove" data-cart-remove="' + itemKey + '" aria-label="Remove">&times;</button>'
        + '</div>';
    }).join('');

    itemsContainer.innerHTML = itemsHTML;

    if (subtotal) {
      subtotal.textContent = formatMoney(cart.total_price);
    }

    attachCartItemListeners();
  }

  function attachCartItemListeners() {
    document.querySelectorAll('[data-cart-change]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-cart-change');
        var delta = parseInt(btn.getAttribute('data-delta'));
        changeCartItem(key, delta);
      });
    });
    document.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-cart-remove');
        removeCartItem(key);
      });
    });

    document.querySelectorAll('[data-cart-remove-bundle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var keysValue = btn.getAttribute('data-cart-remove-bundle') || '';
        var keys = keysValue.split('|').map(function(s) { return s.trim(); }).filter(Boolean);
        if (!keys.length) return;
        removeCartBundle(keys);
      });
    });
  }

  function removeCartBundle(keys) {
    var latestCart = null;
    var chain = Promise.resolve();
    keys.forEach(function(key) {
      chain = chain.then(function() {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) { latestCart = cart; });
      });
    });
    chain.then(function() {
      if (latestCart) {
        renderCartContents(latestCart);
        updateCartCount(latestCart.item_count);
        updateShippingBar(latestCart.total_price);
        if (window.VelunaCrossSell) window.VelunaCrossSell.render();
      } else {
        loadCartContents();
      }
    }).catch(function(e) {
      console.error('[Cart] Bundle remove error:', e);
      loadCartContents();
    });
  }

  function changeCartItem(key, delta) {
    var qtyEl = document.querySelector('[data-cart-item-key="' + key + '"] .veluna-cart-drawer__quantity-value');
    var currentQty = qtyEl ? parseInt(qtyEl.textContent) : 1;
    var newQty = Math.max(0, currentQty + delta);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCartContents(cart);
      updateCartCount(cart.item_count);
      updateShippingBar(cart.total_price);
      if (window.VelunaCrossSell) window.VelunaCrossSell.render();
    })
    .catch(function(e) { console.error('[Cart] Change error:', e); });
  }

  function removeCartItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCartContents(cart);
      updateCartCount(cart.item_count);
      updateShippingBar(cart.total_price);
      if (window.VelunaCrossSell) window.VelunaCrossSell.render();
    })
    .catch(function(e) { console.error('[Cart] Remove error:', e); });
  }

  function updateCartCount(count) {
    document.querySelectorAll('.veluna-header__cart-count, [data-cart-count]').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(attachCartIconHandlers, 100);
  });

  window.VelunaCartDrawer = {
    open: openCartDrawer,
    close: closeCartDrawer,
    load: loadCartContents
  };
  window.closeVelunaCartDrawer = closeCartDrawer;
})();
